export enum SectionsClaims {
  ADMIN_MANAGEMENT = 'admin',
  VESSELS_MANAGEMENT = 'vessels-management',
  PARAMS_MANAGEMENT = 'parameters-management',
  STAYS_MANAGEMENT = 'stays-management',
  PROFILES_MANAGEMENT = 'profiles-management'
}
